// This file is designed to add extra functionalities to Plugin class

var NpawAppAnalyticsGettersMixin = {
  getContext: function () {
    return 'Default'
  },

  getScrollDepth: function () {
    var ret = this.plugin.storage.getSession('pageScrollDepth')
    this.plugin.storage.removeSession('pageScrollDepth')
    return ret
  },

  getPageName: function () {
    if (typeof document !== 'undefined' && document.title) {
      return document.title
    }
  },

  getPageLoadTime: function () {
    return this.plugin.browserLoadTimes.getPageLoadTime()
  },

  getIsSessionExpired: function () {
    var now = new Date().getTime()
    return !this.plugin.getSession() || (this.getFirstActive() < now - this.sessionExpire)
  },

  getIsDataExpired: function () {
    var now = new Date().getTime()
    return !this.plugin.storage.isEnabled() || !this.plugin.getStoredData() || (this.getFirstActive() < now - this.sessionExpire)
  },

  getLastActive: function () {
    return this.plugin.storage.getStorages('lastactive')
  },

  setLastActive: function (last) {
    this.plugin.storage.setStorages('lastactive', last)
  }
}

module.exports = NpawAppAnalyticsGettersMixin
